export const SELECT_QUESTION = 'app/EditSessionPage/SELECT_QUESTION';
export const CLEAR_ERROR = 'app/EditSessionPage/CLEAR_ERROR';

export const CREATE_QUESTION_REQUEST =
  'app/EditSessionPage/CREATE_QUESTION_REQUEST';
export const CREATE_QUESTION_SUCCESS =
  'app/EditSessionPage/CREATE_QUESTION_SUCCESS';
export const CREATE_QUESTION_ERROR =
  'app/EditSessionPage/CREATE_QUESTION_ERROR';

export const GET_QUESTIONS_REQUEST =
  'app/EditSessionPage/GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_SUCCESS =
  'app/EditSessionPage/GET_QUESTIONS_SUCCESS';
export const GET_QUESTIONS_ERROR = 'app/EditSessionPage/GET_QUESTIONS_ERROR';

export const EDIT_QUESTION_REQUEST =
  'app/EditSessionPage/EDIT_QUESTION_REQUEST';
export const EDIT_QUESTION_SUCCESS =
  'app/EditSessionPage/EDIT_QUESTION_SUCCESS';
export const EDIT_QUESTION_ERROR = 'app/EditSessionPage/EDIT_QUESTION_ERROR';

export const ADD_QUESTION_IMAGE_REQUEST =
  'app/EditSessionPage/ADD_QUESTION_IMAGE_REQUEST';
export const ADD_QUESTION_IMAGE_SUCCESS =
  'app/EditSessionPage/ADD_QUESTION_IMAGE_SUCCESS';
export const ADD_QUESTION_IMAGE_ERROR =
  'app/EditSessionPage/ADD_QUESTION_IMAGE_ERROR';

export const DELETE_QUESTION_IMAGE_REQUEST =
  'app/EditSessionPage/DELETE_QUESTION_IMAGE_REQUEST';
export const DELETE_QUESTION_IMAGE_SUCCESS =
  'app/EditSessionPage/DELETE_QUESTION_IMAGE_SUCCESS';
export const DELETE_QUESTION_IMAGE_ERROR =
  'app/EditSessionPage/DELETE_QUESTION_IMAGE_ERROR';

export const UPDATE_QUESTION_IMAGE_REQUEST =
  'app/EditSessionPage/UPDATE_QUESTION_IMAGE_REQUEST';
export const UPDATE_QUESTION_IMAGE_SUCCESS =
  'app/EditSessionPage/UPDATE_QUESTION_IMAGE_SUCCESS';
export const UPDATE_QUESTION_IMAGE_ERROR =
  'app/EditSessionPage/UPDATE_QUESTION_IMAGE_ERROR';

export const ADD_ANSWER_IMAGE_REQUEST =
  'app/EditSessionPage/ADD_ANSWER_IMAGE_REQUEST';
export const ADD_ANSWER_IMAGE_SUCCESS =
  'app/EditSessionPage/ADD_ANSWER_IMAGE_SUCCESS';
export const ADD_ANSWER_IMAGE_ERROR =
  'app/EditSessionPage/ADD_ANSWER_IMAGE_ERROR';

export const DELETE_ANSWER_IMAGE_REQUEST =
  'app/EditSessionPage/DELETE_ANSWER_IMAGE_REQUEST';
export const DELETE_ANSWER_IMAGE_SUCCESS =
  'app/EditSessionPage/DELETE_ANSWER_IMAGE_SUCCESS';
export const DELETE_ANSWER_IMAGE_ERROR =
  'app/EditSessionPage/DELETE_ANSWER_IMAGE_ERROR';

export const UPDATE_ANSWER_IMAGE_REQUEST =
  'app/EditSessionPage/UPDATE_ANSWER_IMAGE_REQUEST';
export const UPDATE_ANSWER_IMAGE_SUCCESS =
  'app/EditSessionPage/UPDATE_ANSWER_IMAGE_SUCCESS';
export const UPDATE_ANSWER_IMAGE_ERROR =
  'app/EditSessionPage/UPDATE_ANSWER_IMAGE_ERROR';

export const COPY_QUESTION_REQUEST =
  'app/EditSessionPage/COPY_QUESTION_REQUEST';
export const COPY_QUESTION_SUCCESS =
  'app/EditSessionPage/COPY_QUESTION_SUCCESS';
export const COPY_QUESTION_ERROR = 'app/EditSessionPage/COPY_QUESTION_ERROR';

export const COPY_EXTERNALLY_QUESTION_REQUEST =
  'app/EditSessionPage/COPY_EXTERNALLY_QUESTION_REQUEST';
export const COPY_EXTERNALLY_QUESTION_SUCCESS =
  'app/EditSessionPage/COPY_EXTERNALLY_QUESTION_SUCCESS';
export const COPY_EXTERNALLY_QUESTION_ERROR =
  'app/EditSessionPage/COPY_EXTERNALLY_QUESTION_ERROR';

export const CHANGE_QUESTION_TYPE_REQUEST =
  'app/EditSessionPage/CHANGE_QUESTION_TYPE_REQUEST';
export const CHANGE_QUESTION_TYPE_SUCCESS =
  'app/EditSessionPage/CHANGE_QUESTION_TYPE_SUCCESS';
export const CHANGE_QUESTION_TYPE_ERROR =
  'app/EditSessionPage/CHANGE_QUESTION_TYPE_ERROR';

export const REORDER_QUESTION_LIST_REQUEST =
  'app/EditSessionPage/REORDER_QUESTION_LIST_REQUEST';
export const REORDER_QUESTION_LIST_SUCCESS =
  'app/EditSessionPage/REORDER_QUESTION_LIST_SUCCESS';
export const REORDER_QUESTION_LIST_ERROR =
  'app/EditSessionPage/REORDER_QUESTION_LIST_ERROR';

export const DELETE_QUESTION_REQUEST =
  'app/EditSessionPage/DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_SUCCESS =
  'app/EditSessionPage/DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_ERROR =
  'app/EditSessionPage/DELETE_QUESTION_ERROR';

export const DELETE_QUESTIONS_REQUEST =
  'app/EditSessionPage/DELETE_QUESTIONS_REQUEST';
export const DELETE_QUESTIONS_SUCCESS =
  'app/EditSessionPage/DELETE_QUESTIONS_SUCCESS';
export const DELETE_QUESTIONS_ERROR =
  'app/EditSessionPage/DELETE_QUESTIONS_ERROR';

export const UPDATE_QUESTION_DATA = 'app/EditSessionPage/UPDATE_QUESTION_DATA';

export const UPDATE_QUESTION_SETTINGS =
  'app/EditSessionPage/UPDATE_QUESTION_SETTINGS';

export const CREATE_QUESTION_GROUP_REQUEST =
  'app/EditSessionPage/CREATE_QUESTION_GROUP_REQUEST';

export const CREATE_QUESTIONS_SUCCESS =
  'app/EditSessionPage/CREATE_QUESTIONS_SUCCESS';
export const UPDATE_VARIABLE = 'app/EditSessionPage/UPDATE_VARIABLE';
